import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { LOGO_MAIN } from "@/data/content";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bun venit!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen flex items-center justify-center bg-bg p-6">
      <div className="w-full max-w-md card-soft p-8 md:p-10">
        <div className="flex flex-col items-center text-center">
          <img src={LOGO_MAIN} alt="DOTAPAN" className="h-16" />
          <div className="h-10 w-10 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center mt-6">
            <Lock className="h-4 w-4 text-gold" />
          </div>
          <h1 className="font-display text-2xl text-text mt-4">Acces administrator</h1>
          <p className="text-sm text-text-soft mt-2">Doar pentru echipa DOTAPAN.</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-xs uppercase tracking-[0.2em] text-text-soft">Email</Label>
            <Input id="email" data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-12 rounded-xl" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-xs uppercase tracking-[0.2em] text-text-soft">Parolă</Label>
            <Input id="password" data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-12 rounded-xl" />
          </div>
          <Button type="submit" className="btn-gold w-full rounded-full h-12 mt-2" disabled={loading} data-testid="admin-login-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            {loading ? "Se autentifică..." : "Autentificare"}
          </Button>
        </form>
        <div className="mt-6 text-center">
          <Link to="/" className="text-xs text-text-soft hover:text-gold">← Înapoi pe site</Link>
        </div>
      </div>
    </div>
  );
}
